<template>
  <div class="wrap">
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :backFalg="true"
      @back="back"
      :isDefault="true"
      :defaultSearch="{name: manageData.name }"
    ></SearchComponent>

    <TablePublic 
      :arraySpanMethod="objectSpanMethod" 
      :colLists="colLists" 
      :tableData="tableData" 
      :paginationFlag="true"
      :showIndex="false" 
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
     >
      <template slot="index" slot-scope="scope">
         <span>{{ customMergeIndex(indexObj, scope.index) }}</span>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          class="button"
          type="text"
          size="small"
          @click="handleView(scope.data, scope.$index)"
        >详情</el-button>
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component v-if="dialogVisible" :ref="currentView" :is="currentView"></component>
    </Mdialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { userByRoleList } from '@/api/system/system'
import { getVisitTaskCropList } from '@/api/system/manage'
import SearchComponent from '@/components/searchComponent'
import taskDetail from '@/views/detail/interview/components/detail' //查看详情
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
export default {
  components: {
    TablePublic,
    SearchComponent,
    taskDetail,
    Mdialog,
  },
  data() {
    return {
      type: '',
      dialogVisible: false,
      title: '',
      currentView: '',
      queryParams: {},
      colLists: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          formSolt: true,
          width: '55'
        },
        {
          prop: 'taskBizNo',
          label: '走访任务单号',
          isTrue: true,
        },
        {
          prop: 'qcOperatorName',
          label: '品控人员',
          isTrue: true,
        },
        {
          prop: 'visitedDate',
          label: '走访日期',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄',
          isTrue: true,
        },
        {
          prop: 'occupiedArea',
          label: '果园亩数',
          isTrue: true,
        },
        {
          prop: 'estimatedTotalOutput',
          label: '预估总产值(斤)',
          isTrue: true,
        },
        {
          prop: 'estimatedUnitPrice',
          label: '预售单价(元)',
          isTrue: true,
          width: 140,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 320,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'name',
          placeholder: '果园名称',
          class: 'home',
          disabled: true,
          type: 'input',
        },

        {
          model: 'visitTime',
          placeholder: '请选择走访年份',
          class: 'home',
          type: 'year',
        },
        {
          model: 'cultivationMethodSpecAttrKey',
          placeholder: '请选择培育方式',
          value: 'dictValue',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
        {
          model: 'userId',
          placeholder: '请选择品控人员',
          value: 'id',
          label: 'userName',
          list: [],
          type: 'select',
        },
        {
          model: 'taskBizNo',
          placeholder: '请输入走访任务单号',
          class: 'home',
          type: 'input',
        },
      ],
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
      indexObj: {},// 用于记录索引项对应的实际序号
    }
  },
  computed: {
    ...mapState({
      manageData: (state) => state.manage.infoDetail || {},
      cultivationList: (state) => (state.system.dictList && state.system.dictList.cultivationMethod) || [],
    }),
  },
  created(){
    this.getDictList({types: 'landStatus,fertilizerType,cultivationMethod'})
    this.getUserByRoles()
    this.getList()
  },
  watch:{
    cultivationList(newVal){
      this.selectOrInputList[2].list = newVal
    }
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getUserByRoles(){
      userByRoleList({roleName: '品控员'}).then(res => {
        if (res.flag) {
          this.selectOrInputList[3].list = res.data
        }
      })
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      this.queryParams.plantationId = this.manageData.id
      getVisitTaskCropList(this.queryParams).then(res => {
        if (res.flag) {
          this.tableData = res.data.items.map(item=>{
            item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
            return item
          })
          this.total = res.data.totalCount
          this.getSpanArr(this.tableData)
        }
      })
      .catch((error) => {
        console.log(error)
      })
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看走访信息'
      this.currentView = 'taskDetail'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          const task = {id: row.taskId}
          this.$refs[this.currentView].getDetails(task)
        }
      })
    },
    cancel() {
      this.dialogVisible = false
      // this.$refs[this.currentView].reset()
    },
    // 合并行
    getSpanArr(data) {
      this.spanArr1 = []
      for (let i = 0; i < data.length; i++) {
        // 第一列
        if (i === 0) {
          this.spanArr1.push(1)
          this.pos1 = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].taskBizNo === data[i - 1].taskBizNo) {
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            this.spanArr1.push(1)
            this.pos1 = i
          }
        }
      }
      this.indexObj = this.dealMergeIndexObj(this.spanArr1)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3, 9].includes(columnIndex)) {
        return {
          rowspan: this.mergeIndexRows(row, this.tableData, rowIndex, ['taskBizNo']),
          colspan: 1,
        }
      }
      if (columnIndex === 4) {
        return {
          rowspan: this.mergeIndexRows(row, this.tableData, rowIndex, ['cultivationMethodSpecValueKey']),
          colspan: 1,
        }
      }
    },
    back() {
      this.$router.push({ path: '/manage' })
    },
    handleSee() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '查看走访信息'
        this.currentView = 'taskDetail'
        this.type = 'taskDetail'
      })
    },
    handleRecord() {
      this.$router.push({ path: '/record' })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
        plantationId: this.manageData.id
      }
      this.getList()
    },
    reset(){}
  },
}
</script>

<style scoped lang='less'>
.wrap {
  font-size: 14px;
}
/deep/ .delbutton.el-button--text {
  color: red;
}
.el-button--text {
  font-size: 14px;
}
</style>